import React, { FC } from 'react';

import Upload from './Upload';

import Button from 'ui/components/Buttons';
import { UploadButtonProps } from './types';
import { Export1Outline } from 'ui/components/Icon';

const UploadButton: FC<UploadButtonProps> = ({ icon, children, multiple, ...props }) => (
  <Upload {...props} multiple={multiple}>
    <Button icon={icon}>{children ? children : multiple ? 'Выбрать файлы' : 'Выбрать файл'}</Button>
  </Upload>
);

UploadButton.defaultProps = {
  icon: <Export1Outline />,
};

export default UploadButton;
